module.exports = __webpack_public_path__ + "img/hotel.417a3aef.png";